import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { Button, Form } from "react-bootstrap-v5";
import { CategoryService, SubCategoryService } from "../../Services";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
// import { SubCategoryService } from "../../Services";
// import { SubCategoryService } from "../../Services";

export const AddSubCategory = ({ category, getDetail, setAddModal }) => {
  const [, setForceUpdate] = useState("");
  const [id, setId] = useState("");
  const [data, setData] = useState([]);
  const [state, setState] = useState({
    subcategory_name: "",
  });

  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  

  // const [category,setCategory] = useState({
  // 	category_id:''
  // })

  const handleChange = (e) => {
    setId(e.target.value);
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let validate = Validator.current.allValid();
    if (validate) {
      const obj = {
        subcategory_name: state.subcategory_name,
        // category_id: id,
      };
      await SubCategoryService.addSubCategory(obj).then((res) => {
        if (res.status === true) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
        getDetail();
        setAddModal(false);
      });
    } else {
      Validator.current.showMessages();
    }
  };

  const getCategory = async () => {
    await CategoryService.getCategory()
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCategory();
  }, []);

  return (
    <div>
      {/* <div className="mb-3 col-12">
        <Form.Select
          onChange={(e) => {
            handleChange(e);
          }}
          aria-label="Default select example"
        >
          {data && data?.length > 0 && data.map((item, index) => {
            return (
              <option value={item._id} key={index}>
                {item?.category_name}
              </option>
            );
          })}
        </Form.Select>
      </div> */}
      <form onSubmit={handleSubmit}>
        <div className="mb-3 col-12">
          {/* <label className="form-label mb-1">Sub Category Name</label> */}
          <input
            type="text"
            className="form-control"
            name="subcategory_name"
            // value={state.category_name}
            placeholder="Name"
            onChange={(e) => handleInput(e)}
          />
          {Validator.current.message(
          "Sub Category name",
          state.subcategory_name,
          "required",
          { className: "text-danger" }
        )}
        </div>
        <Button type="submit" className="btn btn-primary">
          submit
        </Button>
      </form>
    </div>
  );
};
